import api from 'utils/api';

export const fetchPatientProfileApi = (patientId) =>
	api.get(`/referrer/patients/${patientId}/profile`);

export const fetchPatientCalendarApi = (patientId) =>
	api.get(`/referrer/patients/${patientId}/calendar`);

export const fetchPatientGroupsApi = (patientId) =>
	api.get(`/referrer/patients/${patientId}/groups`);

export const fetchPatientOqApi = (patientId) =>
	api.get(`/referrer/patients/${patientId}/oq`);
